import React from 'react';

import { flagStyles } from '../settings';

const SvgSS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4944px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSS;
